import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ClockCircleOutlined, CloudServerOutlined, CloudUploadOutlined, ExperimentOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { App, List, Space, Spin, Tooltip } from "antd";
import { observer } from "mobx-react";
import { copyToClipboard } from "@devowl-wp/react-utils";
import { PluginUpdateLicenseTelemetryDataModal } from "./licenseTelemetryDataModal.js";
import { __, _i } from "../../utils/i18n.js";
const PluginUpdateLicenseListItem = observer(({ license, onDeactivate })=>{
    const { message } = App.useApp();
    const { busy, uuid, installationType, telemetryDataSharingOptIn, blogName, code, hint, remote, programmatically, host, blog, store: { needsLicenseKeys } } = license;
    const infoHint = typeof hint === "object" && hint && hint.validateStatus === "info" ? hint : null;
    const activeFeatureFlags = Object.entries(remote?.featureFlags || {}).filter(([_, value])=>value).map(([key])=>key);
    return /*#__PURE__*/ _jsx(Spin, {
        spinning: busy,
        children: /*#__PURE__*/ _jsxs(List.Item, {
            style: {
                paddingLeft: 0,
                paddingRight: 0
            },
            actions: [
                needsLicenseKeys && /*#__PURE__*/ _jsxs(Space, {
                    children: [
                        /*#__PURE__*/ _jsx(Tooltip, {
                            title: __("Client UUID: %s, click to copy.", uuid),
                            children: /*#__PURE__*/ _jsx(CloudServerOutlined, {
                                style: {
                                    cursor: "pointer"
                                },
                                onClick: ()=>{
                                    copyToClipboard(uuid);
                                    message.success("Successfully copied client UUID key to clipboard!");
                                }
                            })
                        }),
                        installationType === "production" ? __("Production") : installationType === "development" ? __("Development") : "n/a"
                    ]
                }, "installationType"),
                remote && /*#__PURE__*/ _jsxs(Space, {
                    children: [
                        /*#__PURE__*/ _jsx(ClockCircleOutlined, {}),
                        __("Activated %s", new Date(remote.licenseActivation.activatedAt).toLocaleString(document.documentElement.lang))
                    ]
                }, "activatedAt"),
                /*#__PURE__*/ _jsx(PluginUpdateLicenseTelemetryDataModal, {
                    license: license,
                    disabled: !telemetryDataSharingOptIn,
                    children: /*#__PURE__*/ _jsxs(Space, {
                        style: {
                            cursor: "pointer"
                        },
                        children: [
                            /*#__PURE__*/ _jsx(CloudUploadOutlined, {}),
                            telemetryDataSharingOptIn ? __("Telemetry data sharing enabled") : __("Telemetry data sharing disabled")
                        ]
                    }, "telemetryDataSharingOptIn")
                }, "telemetryModal"),
                !programmatically && /*#__PURE__*/ _jsx("a", {
                    className: "button-link",
                    onClick: async ()=>{
                        try {
                            await license.deactivate();
                        } catch (e) {
                            message.error(e.responseJSON.message);
                        }
                        onDeactivate?.(license);
                    },
                    children: __("Deactivate")
                }, "deactivate")
            ].filter(Boolean),
            children: [
                /*#__PURE__*/ _jsx(List.Item.Meta, {
                    title: blogName,
                    description: needsLicenseKeys ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            __("Your license key"),
                            ": ",
                            /*#__PURE__*/ _jsx("code", {
                                children: code
                            }),
                            infoHint && /*#__PURE__*/ _jsx(Tooltip, {
                                title: infoHint.help,
                                children: /*#__PURE__*/ _jsx(InfoCircleOutlined, {
                                    style: {
                                        marginLeft: 6
                                    }
                                })
                            }),
                            activeFeatureFlags.length > 0 && /*#__PURE__*/ _jsx(Tooltip, {
                                title: __("Feature flags enabled: %s", activeFeatureFlags.join(", ")),
                                children: /*#__PURE__*/ _jsx(ExperimentOutlined, {
                                    style: {
                                        marginLeft: 6
                                    }
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            __("Your installation is fully activated."),
                            /*#__PURE__*/ _jsx("div", {
                                style: {
                                    marginTop: 15
                                },
                                children: /*#__PURE__*/ _jsx("a", {
                                    rel: "noreferrer",
                                    href: __("https://devowl.io/knowledge-base/upgrade-free-to-pro-version/"),
                                    className: "button",
                                    target: "_blank",
                                    children: __("Enter license key to unlock PRO features")
                                })
                            })
                        ]
                    })
                }),
                programmatically && /*#__PURE__*/ _jsx("div", {
                    className: "notice notice-info inline below-h2 notice-alt",
                    style: {
                        margin: "0 0 10px 0"
                    },
                    children: /*#__PURE__*/ _jsx("p", {
                        children: _i(__("This license cannot be deactivated manually because it is configured programmatically. That means you have used the {{a}}activation filter{{/a}} for host {{code}}%s{{/code}} (Blog ID: %d). Please remove the filter to deactivate the license!", host, blog), {
                            code: /*#__PURE__*/ _jsx("code", {}),
                            a: /*#__PURE__*/ _jsx("a", {
                                href: "https://docs.devowl.io/real-cookie-banner/hooks/DevOwl_RealProductManager_License_Programmatic_$slug.html",
                                target: "_blank",
                                rel: "noreferrer"
                            })
                        })
                    })
                })
            ]
        })
    });
});
export { PluginUpdateLicenseListItem };
